import './Login.scss';

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';
import Button from 'react-bootstrap/Button';

import axios from 'axios';

/*
This component contains the Login form and deals with the validation around this.
 */
const Login = () => {

  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [passwordError, setPasswordErrors] = useState({ password: '' });
  const [usernameError, setUsernameError] = useState({ username: '' })
  const history = useHistory();

  /**
   * FUNCTION: loginValidation
   * This checks if the username or password is empty,
   * if so displays the relevant error in span.help-block
   * @param event - the button click.
   */
  const loginValidation = (event) => {
    event.preventDefault();
    let valid = true;
    if (credentials.username === '') {
      setUsernameError({ ...usernameError, username: 'Please enter a username' });
      valid = false;
    }
    if (credentials.password === '') {
      setPasswordErrors({ ...passwordError, password: 'Please enter a password' });
      valid = false;
    }
    if (valid) {
      login(credentials.username, credentials.password);
    }
  }

  /**
   * This is the API call to the server, sending over the login
   * credentials and then setting the user or suggesting the
   * details were incorrect
   * @param username - the username of the user
   * @param password - password for the user.
   * @return {Promise<void>} -- returned from the API
   */
  const login = (username, password) => {
    axios.post('/auth/login', { username, password })
      .then(() => history.push('/'))
      .catch(err => {
        setUsernameError({ ...usernameError, username: 'Please enter a valid username' });
        setPasswordErrors({ ...passwordError, password: 'Please enter a valid password' });
      });
  }

  /**
   * This is the component return.
   * @return {JSX.Element} Login form component
   */
  return (
    <div className='body-image' style={{ backgroundImage: `url( ${`${process.env.PUBLIC_URL}/images/background.jpg`})` }}>
      <div className='login-form-container'>
        <div className='form-image-container'>
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt='logo' width='70' height='70' />
          <p>
            Non-Conformance Reporting <br />Application</p>
        </div>
        <Form className='form-inner-container' onSubmit={(e) => {
          loginValidation(e);
        }}>
          <FormGroup>
            <span
              className='help-block'>{usernameError.username} &nbsp;</span> {/*&nbsp; is require to give height*/}
            <FormControl type='username' placeholder='Username' autoComplete='on'
              onChange={e => setCredentials({ ...credentials, username: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <span
              className='help-block'>{passwordError.password} &nbsp;</span> {/*&nbsp; is require to give height*/}
            <FormControl type='password' placeholder='Password' autoComplete='on'
              onChange={e => setCredentials({ ...credentials, password: e.target.value })} />
          </FormGroup>
          <Button type='submit' className='login-button'>
            LOGIN
          </Button>
        </Form>
      </div>
    </div>
  )
}

export { Login };
